/** The tabs of the page of an inbound in Atelier, in the order it shows them (`?tab=`). */
export const inboundTabs = ["lines", "documents", "outcome", "details", "notes", "history"] as const;
export type InboundTab = (typeof inboundTabs)[number];
